export const CFE_REPRESENTATIVE_QUESTION_LABEL =
  'Les cotisations CFE du prospect sont-elles payées par un mandataire ?';

export const FIDUCIARY_CONTACT_LABEL = 'FIDUCIARY';

export const CFE_REPRESENTATIVE_OFFER_CODES = [
  'INDIVIDUAL_HEALTH',
  'SELF_EMPLOYED_WORKER_PROTECTION'
];
